import { PlacementNS, SizeNS } from './types'
import * as TinyMCE from './TinyMCE'

import { CardLevelNS, CardVariantNS } from '../components/Card'
import { BannerIconVariantNS, BannerVariantNS } from '../components/Banner'
import {
  ButtonVariantNS,
  ButtonModifierNS,
  ButtonTypeNS,
} from '../components/Button'
import { FontWeightNS, FontVariantNS, FontStyleNS } from '../components/Font'
import { HeaderTypeNS } from '../components/Header'
import { IconVariantNS } from '../components/Icon'
import { InputVariantNS } from '../components/Input'
import { LinkVariantNS } from '../components/Link'
import { ModalIconVariantNS } from '../components/Modal'
import { NotationVariantNS } from '../components/Notation'
import {
  SegmentedControllerVariantNS,
  SegmentedControllerSegmentVariantNS,
} from '../components/SegmentedController'
import { SpinnerVariantNS } from '../components/Spinner'
import { TabVariantNS, TabsVariantNS } from '../components/Tabs'
import { TextAreaResizeNS, TextAreaVariantNS } from '../components/TextArea'
import { ToastVariantNS } from '../components/Toast'
import { TokenVariantNS } from '../components/Token'
import { TableVariantNS, TableCellVariantNS } from '../components/Table'

import {
  BoxDisplayNS,
  BoxSpaceAttributeNS,
  FlexAlignNS,
  FlexDirectionNS,
  FlexJustifyNS,
  FlexWrapNS,
  InlineFlexStyleKeysNS,
  SideShorthandNS,
  TextAlignNS,
} from '../layouts/Box'
import { ControlVariantNS } from '../layouts/ListPage'
import { ToolHeaderBadgeVariantNS } from '../layouts/ToolHeader'

import { OverlayTriggerVariantNS } from '../state/OverlayTrigger'

export default {
  // // utils
  TinyMCE,
  Size: SizeNS,
  Placement: PlacementNS,
  // // components
  BannerIconVariant: BannerIconVariantNS,
  BannerVariant: BannerVariantNS,
  ButtonVariant: ButtonVariantNS,
  ButtonModifier: ButtonModifierNS,
  ButtonType: ButtonTypeNS,
  CardLevel: CardLevelNS,
  CardVariant: CardVariantNS,
  FontWeight: FontWeightNS,
  FontVariant: FontVariantNS,
  FontStyle: FontStyleNS,
  HeaderType: HeaderTypeNS,
  IconVariant: IconVariantNS,
  InputVariant: InputVariantNS,
  LinkVariant: LinkVariantNS,
  ModalIconVariant: ModalIconVariantNS,
  NotationVariant: NotationVariantNS,
  SegmentedControllerVariant: SegmentedControllerVariantNS,
  SegmentedControllerSegmentVariant: SegmentedControllerSegmentVariantNS,
  SpinnerVariant: SpinnerVariantNS,
  TabVariant: TabVariantNS,
  TabsVariant: TabsVariantNS,
  TableVariant: TableVariantNS,
  TableCellVariant: TableCellVariantNS,
  TextAreaResize: TextAreaResizeNS,
  TextAreaVariant: TextAreaVariantNS,
  ToastVariant: ToastVariantNS,
  TokenVariant: TokenVariantNS,
  // layout
  BoxDisplay: BoxDisplayNS,
  BoxSpaceAttribute: BoxSpaceAttributeNS,
  ControlVariant: ControlVariantNS,
  FlexAlign: FlexAlignNS,
  FlexDirection: FlexDirectionNS,
  FlexJustify: FlexJustifyNS,
  FlexWrap: FlexWrapNS,
  InlineFlexStyleKeys: InlineFlexStyleKeysNS,
  SideShorthand: SideShorthandNS,
  TextAlign: TextAlignNS,
  ToolHeaderBadgeVariant: ToolHeaderBadgeVariantNS,
  // state
  OverlayTriggerVariant: OverlayTriggerVariantNS,
}
